export const ensureVendorScript = (src: string, onLoad?: () => void): void => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement('script');

  script.async = true;
  script.src = src;

  if (onLoad) {
    script.addEventListener('load', onLoad);
  }

  document.head.appendChild(script);
};
